import { title } from 'assets/jss/material-kit-react.jsx';

const productStyle = {
  section: {
    padding: '100px 15px',
    textAlign: 'center',
    '@media (max-width: 992px)': {
      padding: '35px 15px',
    },
  },
  title: {
    ...title,
    marginBottom: '1rem',
    minHeight: '32px',
    textDecoration: 'none',
  },
  description: {
    color: '#000',
  },
};

export default productStyle;
